<template>
  <div class="list-page">
    <header>
      <button
        type="button"
        :aria-label="$t('yuebao.back')"
        @click="$router.back()"
      >
        ‹
      </button><h1>{{ $t('yuebao.orderList') }}</h1><span />
    </header>
    <div class="filters">
      <button
        v-for="item in filters"
        :key="item.value"
        type="button"
        :class="{active: status === item.value}"
        @click="selectStatus(item.value)"
      >
        {{ item.text }}
      </button>
    </div>
    <main>
      <button
        v-for="(order, index) in orders"
        :key="order.order_no || order.id || index"
        type="button"
        class="order"
        @click="open(order)"
      >
        <div class="order-head">
          <strong>{{ productName(order) }}</strong><span :class="statusClass(order.status)">{{ statusText(order.status) }}</span>
        </div>
        <p class="number">
          {{ $t('yuebao.orderNo') }}：{{ display(order.order_no) }}
        </p>
        <div class="stats">
          <div><b>{{ $t('utils.moneyMark') }}{{ money(principal(order)) }}</b><small>{{ $t('yuebao.principal') }}</small></div><div><b class="rate">{{ rate(order) }}</b><small>{{ $t('yuebao.annualRate') }}</small></div><div><b>{{ $t('utils.moneyMark') }}{{ money(income(order)) }}</b><small>{{ $t('yuebao.income') }}</small></div>
        </div>
        <p class="time">
          {{ $t('yuebao.startTime') }}：{{ display(order.start_at) }} · {{ $t('yuebao.term') }}：{{ term(order) }}
        </p>
      </button>
      <van-empty
        v-if="!loading && !orders.length"
        :description="$t('yuebao.noOrders')"
      />
      <button
        v-if="hasMore"
        type="button"
        class="more"
        :disabled="loading"
        @click="load"
      >
        {{ loading ? $t('yuebao.loading') : $t('yuebao.loadMore') }}
      </button>
    </main>
  </div>
</template>
<script>
import Vue from 'vue';
import { Empty } from 'vant';
import Fetch from '../../../utils/fetch';
Vue.use(Empty);
export default {
  name: 'YuebaoOrders',
  data() { return { orders: [], page: 1, limit: 10, status: '', loading: false, hasMore: false }; },
  computed: { filters() { return [{ value: '', text: this.$t('yuebao.allOrders') }, { value: '0', text: this.$t('yuebao.statusHolding') }, { value: '1', text: this.$t('yuebao.statusSettling') }, { value: '2', text: this.$t('yuebao.statusDue') }]; } },
  created() { this.$parent.footer('user', false); }, mounted() { this.load(); },
  methods: {
    load() { if (this.loading) return; this.loading = true; Fetch('/yuebao/orders', { page: this.page, limit: this.limit, status: this.status }, {}, this.page === 1).then(r => { const data = r.data || {}; const list = Array.isArray(data) ? data : (data.list || data.orders || []); this.orders = this.page === 1 ? list : this.orders.concat(list); this.hasMore = data.has_more === true || list.length >= this.limit; if (this.hasMore) this.page += 1; }).catch(() => {}).finally(() => { this.loading = false; }); },
    selectStatus(value) { if (this.status === value) return; this.status = value; this.page = 1; this.orders = []; this.hasMore = false; this.load(); },
    open(order) { const no = order.order_no == null ? order.id : order.order_no; if (no != null && no !== '') this.$router.push('/yuebao/order/' + encodeURIComponent(no)); },
    display(value) { return value == null || value === '' ? '--' : value; }, money(value) { const n = Number(value); return Number.isFinite(n) ? n.toFixed(2) : '0.00'; },
    productName(order) { return this.display(order.product_name || order.name, this.$t('yuebao.unnamedProduct')); }, principal(order) { return order.principal == null ? order.money : order.principal; }, income(order) { return order.paid_interest; },
    rate(order) { const value = order.annual_rate; return value == null || value === '' ? '--' : String(value).replace(/%$/, '') + '%'; },
    term(order) { return order.term_days == null || order.term_days === '' ? '--' : order.term_days + this.$t('utils.day'); },
    statusText(status) { const key = String(status); return { '0': this.$t('yuebao.statusHolding'), '1': this.$t('yuebao.statusSettling'), '2': this.$t('yuebao.statusDue'), '3': this.$t('yuebao.statusAdminSettled') }[key] || this.$t('yuebao.statusUnknown'); }, statusClass(status) { return 'status-' + String(status); }
  }
};
</script>
<style lang="less" scoped>
* { box-sizing: border-box; }
.list-page { min-width: 0; min-height: 100vh; overflow-x: hidden; background: #f4f6f9; color: #252a35; } header { position: sticky; top: 0; z-index: 3; display: flex; align-items: center; justify-content: space-between; height: 54px; padding: 0 12px; color: #fff; background: #2672e8; h1 { font-size: 18px; } button, span { width: 48px; border: 0; color: #fff; background: transparent; font-size: 34px; text-align: left; } }
.filters { position: sticky; top: 54px; z-index: 2; display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); height: 48px; border-bottom: 1px solid #e8ebf0; background: #fff; button { min-width: 0; padding: 0 2px; border: 0; background: #fff; color: #737a87; font-size: 13px; white-space: nowrap; }.active { position: relative; color: #2672e8; font-weight: 600; }.active:after { position: absolute; right: 25%; bottom: 0; left: 25%; height: 2px; background: #2672e8; content: ''; } }
main { padding: 12px; }.order { display: block; width: 100%; margin-bottom: 10px; padding: 15px; border: 1px solid #e9edf2; border-radius: 9px; background: #fff; color: #252a35; text-align: left; }.order-head { display: flex; justify-content: space-between; align-items: center; gap: 10px; strong { min-width: 0; overflow: hidden; font-size: 15px; text-overflow: ellipsis; white-space: nowrap; } span { flex: 0 0 auto; padding: 3px 8px; border-radius: 10px; color: #2672e8; background: #edf3ff; font-size: 11px; }.status-2 { color: #078b46; background: #e9f8ef; }.status-3 { color: #d94635; background: #fff0ee; } }.number, .time { margin-top: 9px; color: #8e95a1; font-size: 11px; line-height: 17px; word-break: break-all; }.stats { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); margin-top: 14px; padding: 13px 0; border-top: 1px solid #f0f2f5; border-bottom: 1px solid #f0f2f5; div { display: flex; min-width: 0; flex-direction: column; } div + div { padding-left: 8px; border-left: 1px solid #f0f2f5; } b { overflow: hidden; font-size: 14px; text-overflow: ellipsis; white-space: nowrap; }.rate { color: #e66634; } small { margin-top: 6px; color: #9299a5; font-size: 10px; } }.more { display: block; width: 120px; margin: 14px auto; padding: 9px; border: 1px solid #dce5f5; border-radius: 18px; color: #2672e8; background: #fff; }
@media (max-width: 340px) { .filters button { font-size: 12px; } main { padding: 8px; }.order { padding: 12px; }.stats b { font-size: 12px; } }
</style>
